
import axios from "axios";
import Vue from "vue";

export default Vue.extend({
  async created() {
    const slug = String(this.$route.params.slug || "");
    const m = slug.match(/^news(\d{4})(\d{2})(\d{2})\.html$/i);
    if (!m) {
      this.$router.replace("/article/news");
      return;
    }
    const dateStr = `${m[1]}-${m[2]}-${m[3]}`;
    try {
      const response = await axios.post(Vue.prototype.apiUrl("get-item"), {
        collection: "article",
        need: { type: "news", date: dateStr },
      });
      const items = (response.data as any[]) || [];
      if (items.length === 1) {
        this.$router.replace(`/article/news/${items[0]._id}`);
        return;
      }
    } catch (_) {
      // fall through to list page
    }
    this.$router.replace("/article/news");
  },
});
